import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import ChartNetworkImpact from '../charts/ChartNetworkImpact';
import { ROADMAP, SOCIAL_VALUES } from '../data/mockData';
import { TrendingUp, Clock, Heart, Zap } from 'lucide-react';

// 区块9：发展规划与社会价值
export default function Section09Roadmap() {
  const valueIcons = [TrendingUp, Zap, Heart, Clock];

  return (
    <SectionWrapper
      id="roadmap"
      title="发展规划与社会价值"
      subtitle="本项目以2026年5月MVP为起点，计划五年内形成师范生培养与县域教育帮扶的国家级参考方案。"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 左侧：垂直时间轴路线图 */}
        <ScrollReveal>
          <div className="glass-card h-full">
            <h3 className="text-2xl font-bold text-gold mb-8">发展路线图</h3>
            <div className="relative pl-8 border-l-2 border-gold/30 space-y-8">
              {ROADMAP.map((item, index) => (
                <div key={index} className="timeline-item relative">
                  <div className="text-cyan font-bold text-lg mb-1">{item.time}</div>
                  <div className="text-xl font-bold text-white mb-2">{item.title}</div>
                  <div className="text-base text-slate-300">{item.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>

        {/* 右侧：4张社会价值量化卡片 */}
        <ScrollReveal delay={150}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 h-full">
            {SOCIAL_VALUES.map((item, index) => {
              const Icon = valueIcons[index];
              return (
                <div key={index} className="glass-card text-center flex flex-col justify-center">
                  <Icon className="w-10 h-10 text-green mx-auto mb-3" />
                  <div className="text-4xl font-black text-gold mb-2">
                    {item.value}
                    {item.suffix && <span className="text-2xl">{item.suffix}</span>}
                  </div>
                  <div className="text-lg font-bold text-white mb-2">{item.label}</div>
                  <div className="text-sm text-slate-400">{item.desc}</div>
                </div>
              );
            })}
          </div>
        </ScrollReveal>
      </div>

      {/* 底部：影响力网络图 */}
      <ScrollReveal delay={200}>
        <div className="glass-card mt-8 min-h-[460px]">
          <ChartNetworkImpact />
        </div>
      </ScrollReveal>
    </SectionWrapper>
  );
}
